<template>
  <div class="flex flex-col">
    <div class="grow">
      <textarea ref='textarea'
                v-model='component.text'
                autofocus='true'
                class="new-text-textarea"
                :style='currentStyle'
                ></textarea>
    </div>

    <div class="flex flex-row flex-wrap">
      <button class="instant-text-button"
              @click='onToggleMode'
              :class='isForegroundMode ? "" : "bg-white"' >
        <format-text :size='12' v-if='isForegroundMode'
                    class='text-white p-0 m-0' />
        <format-text :size='12' v-if='isBackgroundMode'
                    class='bg-gray-100 text-black p-0 m-0' />
          <span v-if='isBackgroundMode' class="p-0 m-0 text-xs text-black">fill</span>
      </button>
      <button v-for='color in colors'
          @click='onSetColor(color)'
          class='instant-text-button'
          :style='{"background-color":color}'
          :key='color'>
        </button>
    </div>

    <div class="flex flex-row my-2 justify-center">
      <h1 class="text-white mr-3">Auto size</h1>
      <toggle-switch v-model='v2'
                    label="Fit to box"
                    class='flex-none text-xs text-white'
                    />
    </div>

    <div v-if='!component.bounded' class="flex flex-row px-6 my-3 justify-center">
      <span class="text-white mr-3">Size</span>
      <numberer v-model='component.size' :step='1' class="flex-none" />
    </div>

    <div class="flex flex-row px-6 my-3 justify-center">
      <span class="text-white mr-3">Text Shadow</span>
      <toggle-switch v-model='component.dropShadow'
                    label="Text shadow"
                    class='flex-none text-xs text-white'
                    />
    </div>
    <div class="flex flex-row flex-wrap mt-1">
      <button v-for='font in fonts'
          @click='onSetFont(font)'
          class='recommender-button px-1'
          :key='font'>
        {{font}}
        </button>
    </div>

    <div class="text-white text-xs">
          <div v-if='!component.bounded' class="flex flex-row my-2">
            <h1 class="heading w-32">Fill Horizontal</h1>
            <toggle-switch v-model='fillHorizontal'
                          label="Fill Width"
                          class='flex-none text-xs text-white'
                          />
          </div>
          <div v-if='!component.bounded' class="flex flex-row">
            <h1 class="heading w-32">Vertical Padding</h1>
            <numberer v-model='component.bgy' class="w-24 flex-none" />
          </div>
    </div>
    <transform-alignment v-if='!component.bounded'
                         :transform='transform'
                        :holder-data='holderData'
                        :render-tools='renderTools'
                        :enable-horizontal='false'
                        @align-vertical='onVerticalAlign'>
      <div class="my-1 flex w-full justify-start flex-row">
          <pbc-button @click='alignMiddle' class="format-button">
            <format-horizontal-align-center :size='12' />Middle
          </pbc-button>
          <pbc-button @click='alignLeft' class="format-button">
            <format-horizontal-align-left :size='12' />Left
          </pbc-button>
          <pbc-button @click='alignRight' class="format-button">
            <format-horizontal-align-right :size='12' />Right
          </pbc-button>
        </div>

    </transform-alignment>

  </div>
</template>
<script>
import colors from '@edit/colors.js';
import ToggleSwitch from '@ui/atoms/ToggleSwitch.vue';
import { mapState } from 'vuex';
import TransformAlignment from '@ui/molecules/TransformAlignment.vue';
import EditingComponentMixin from '@components/editingComponentMixin.js';
import FormatText from '@icons/FormatText.vue';
import FormatHorizontalAlignLeft from '@icons/FormatHorizontalAlignLeft.vue';
import FormatHorizontalAlignRight from '@icons/FormatHorizontalAlignRight.vue';
import FormatHorizontalAlignCenter from '@icons/FormatHorizontalAlignCenter.vue';

export default {
  mixins: [EditingComponentMixin],
  data() {
    let colorMode = 'foreground';
    let alignment = 'center';
    let verticalAlignment = 'center';
    let currentColor = '#ffffff';

    if (this.component.bg) {
      colorMode = 'background';
      currentColor = this.component.bgcolor;
    }

    return {
      colors,
      fonts:[
        // MS Core Fonts
        'Arial', 'Impact', 'Comic Sans MS', 'Courier New', 'Georgia', 'Verdana', 'Tahoma',
        // Popular display & social fonts
        'Bebas Neue', 'Anton', 'Bangers', 'Oswald',
        // Clean sans-serifs
        'Montserrat', 'Roboto', 'Lato', 'Ubuntu',
        // Script & decorative
        'Permanent Marker', 'Lobster', 'Pacifico',
      ],
      textColorForBackgrounds:{
        '#ffffff':'#000000',
        '#000000':'#ffffff'
      },
      colorMode,
      currentColor,
      alignment:'center',
      verticalAlignment:'center',
    }
  },
  mounted() {
    this.$refs.textarea.focus();
    this.setTextAreaHeight();
    this.$emit('validated', true);
  },
  methods: {
    onToggleMode() {
      if (this.isForegroundMode) { 
        this.onSetBackgroundMode();
      } else {
        this.onSetForegroundMode()
      }
    },
    setTextAreaHeight() {
      this.$refs.textarea.style.height = this.$refs.textarea.scrollHeight + "px";
    },
    onSetFont(font) {
      this.component.font = font;
      this.updateTextHolder();
    },
    onSetColor(color) {
      this.currentColor = color;
      this.setColors();
    },
    onSetForegroundMode() {
      this.colorMode = 'foreground';
      if (this.currentColor === '#000000') {
        this.currentColor = '#ffffff';
      }
      //this.currentColor = this.textColorForBackgrounds[this.currentColor];
      this.setColors();
    },
    onSetBackgroundMode() {
      this.colorMode = 'background';
      this.setColors();
    },
    setColors() {
      if (this.colorMode === 'foreground') {
        this.component.color = this.currentColor;
        this.component.bg = false;
      } else {
        this.component.bg = true;
        this.component.bgcolor = this.currentColor;
        const fgcolor = this.textColorForBackgrounds[this.currentColor] || '#ffffff';
        this.component.color = fgcolor;
      }

      this.updateTextHolder();
    },
    onAlign(alignment) {
      this.alignment = alignment;
    },
    onVerticalAlign(alignment) {
      this.verticalAlignment = alignment;
    },
    updateTextHolder() {
      if (this.firstUpdate) {
        this.renderTools.addOnReadyEvent(this.transform, (holder) => {
          const {updateContainerBounds} = this.holderData[this.transform.id];
          this.renderTools.addToUpdateBatch(holder);
          this.renderTools.addToRunBatch( () => {
          this.renderTools.addToRunBatch( () => {
            updateContainerBounds();
          });
          });
          this.firstUpdate = false;
        });
      } else {
        if (!this.holderData[this.transform.id]) {
          console.warn('text is not available yet');
          return;
        }
        const {holder,updateContainerBounds} = this.holderData[this.transform.id];
        this.renderTools.addToUpdateBatch(holder);
        this.renderTools.addToRunBatch( () => {
        this.renderTools.addToRunBatch( () => {
          updateContainerBounds();
        });
        });
      }
      this.$emit('update');
    },
    alignMiddle() {
      this.component.align = 'center';
      this.updateTextHolder();
      this.onAlign('center');
    },
    alignLeft() {
      this.component.align = 'left';
      this.updateTextHolder();
      this.onAlign('left');
    },
    alignRight() {
      this.component.align = 'right';
      this.updateTextHolder();
      this.onAlign('right');
    }
  },
  components:{
    TransformAlignment,
    FormatText,
    FormatHorizontalAlignCenter,
    FormatHorizontalAlignLeft,
    FormatHorizontalAlignRight,
    ToggleSwitch
  },
  computed:{
    v2: {
      get() {
        return this.component.v === 2 && this.component.bounded;
      },
      set(nv) {
        if (nv) {
          this.component.v = 2;
          this.component.bounded = true;
          this.updateTextHolder();
          this.transform.transform.scale.x = 9;
          this.transform.transform.scale.y = 2;
        } else {
          this.component.v = 2;
          this.component.bounded = false;
          this.transform.transform.scale.x = 1;
          this.transform.transform.scale.y = 1;
          this.updateTextHolder();
        }
      }
    },
    fillHorizontal: {
      get() {
        return this.component.bgx !== -1;
      },
      set(nv) {
        this.component.bgx = nv ? 9 : -1;
      }
    },
    isForegroundMode() {
      return this.colorMode === 'foreground';
    },
    isBackgroundMode() {
      return this.colorMode === 'background';
    },
    currentStyle() {
      let s;
      if (this.colorMode === 'background') {
        const fgcolor = this.textColorForBackgrounds[this.currentColor] || '#ffffff';
        s = {
          color: fgcolor,
          'background-color':this.currentColor
        }
      } else {
        s = {
          color: this.currentColor,
        }
      }

      if (this.alignment === 'center') {
        s['text-align'] = 'center';
      } else if (this.alignment === 'left') {
        s['text-align'] = 'left';
      } else if (this.alignment === 'right') {
        s['text-align'] = 'right';
      }

      if (this.verticalAlignment === 'center') {
        s['margin-top'] = 'auto';
        s['margin-bottom'] = 'auto';
      } else if (this.verticalAlignment === 'top') {
        s['margin-bottom'] = 'auto';
      } else if (this.verticalAlignment === 'bottom') {
        s['margin-top'] = 'auto';
      }
      s['padding-top'] = 'auto';
      s['padding-bottom'] = 'auto';

      s['font-family'] = this.component.font;

      if (!this.fillHorizontal) {
        s['width'] = 'auto';
        s['margin-left'] = 'auto';
        s['margin-right'] = 'auto';
      }

      s['font-size'] = this.component.size + 'px';

      //s['padding-top'] = (this.component.bgy/2) + 'rem';
      //s['padding-bottom'] = (this.component.bgy/2) + 'rem';

      return s;
    },
    ...mapState([
      'renderTools',
      'holderData',
      'isAdvancedMode'
    ])
  },
  watch:{
    'component.bg'() {
      this.updateTextHolder();
    },
    'component.text'() {
      this.updateTextHolder();
      this.setTextAreaHeight();
    },
    'component.bgy'() {
      this.updateTextHolder();
      this.setTextAreaHeight();
    }
  }
}
</script>
